import { render } from "./complyon_sync.html?vue&type=template&id=2cca9e09&external"
import script from "./complyon_sync.js?vue&type=script&lang=js&external"
export * from "./complyon_sync.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__